import React, { useState, useEffect, useRef } from 'react';

const MerritoPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const scriptLoaded = useRef(false);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener('open-enquiry-popup', handleOpen);
    
    if (!scriptLoaded.current) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://widgets.in8.nopaperforms.com/emwgts.js";
      document.body.appendChild(script);
      scriptLoaded.current = true;
    }
    
    return () => window.removeEventListener('open-enquiry-popup', handleOpen);
  }, []);

  return (
    <>
      {/* Floating Button (Bottom Right like live site) */}
      <button 
        onClick={() => setIsOpen(true)}
        className="fixed bottom-5 right-5 md:bottom-8 md:right-8 text-white py-3 px-6 md:py-4 md:px-7 rounded-full font-semibold text-[15px] md:text-[16px] tracking-wide shadow-[0_8px_24px_rgba(0,115,170,0.3)] z-[100] hover:-translate-y-1 hover:shadow-[0_10px_32px_rgba(0,115,170,0.5)] transition-all flex items-center justify-center"
        style={{ background: 'linear-gradient(135deg, #0073aa 0%, #005a87 100%)' }}
      >
        Enquiry Now
      </button>

      {/* Popup Overlay */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 transition-opacity duration-300" 
        style={{ opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? 'auto' : 'none' }}
      >
          <div className="rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.3)] w-full max-w-[580px] max-h-[90vh] overflow-hidden relative" style={{ background: 'linear-gradient(to bottom, #ffffff 0%, #f8f9fa 100%)', animation: 'slideUp 0.4s ease' }}>
            
            {/* Modal Header */}
            <div className="p-6 md:p-7 relative text-white" style={{ background: 'linear-gradient(135deg, #0073aa 0%, #005a87 100%)' }}>
              <h2 className="text-[22px] md:text-[26px] font-semibold m-0 tracking-tight !text-white">Admission Enquiry</h2>
              <p className="mt-2 opacity-90 text-[14px]">Fill in your details and we'll get back to you shortly</p>
              <button 
                onClick={() => setIsOpen(false)}
                className="absolute top-5 right-5 md:top-6 md:right-6 w-9 h-9 rounded-full flex items-center justify-center text-[24px] !text-white hover:bg-white/30 hover:rotate-90 transition-all focus:outline-none leading-none"
                style={{ background: 'rgba(255, 255, 255, 0.2)' }}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            
            {/* Form Container */}
            <div className="p-6 md:p-8 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 120px)' }}>
              <div className="npf_wgts" data-height="400px" data-w="eae722ebe962698d283c87789e62f976"></div>
            </div>
          </div>
        </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(50px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      `}} />
    </>
  );
};

export default MerritoPopup;
